import {
  LayoutDashboard, ClipboardList, MonitorPlay, Archive, BarChart3, Siren,
  Building2, Factory, Package, Clock, Ruler, OctagonX, Ban, Users, Globe, Gauge, LifeBuoy, Boxes, Warehouse,
} from "lucide-react";

export const ROLES = {
  superadmin: { label: "Super Admin", rank: 4 },
  admin: { label: "Administrateur", rank: 3 },
  planificateur: { label: "Planificateur", rank: 2 },
  superviseur: { label: "Superviseur", rank: 2 },   // lecture complète du pilotage + corrections de saisie
  magasinier: { label: "Magasinier", rank: 2 },  // AUDIT INV V2 §7 : rôle logistique dédié.
  operateur: { label: "Opérateur", rank: 1 },
};

const PILOTAGE = ["planificateur", "superviseur", "admin", "superadmin"];
// Qui peut ÉCRIRE dans le pilotage (créer/modifier des OF, acquitter des alertes). Le superviseur lit et corrige les saisies, rien de plus.
const PILOTAGE_ECRITURE = ["planificateur", "admin", "superadmin"];
export const canWritePilotage = (role) => PILOTAGE_ECRITURE.includes(role);
const INVENTAIRE_LECTURE = ["planificateur", "magasinier", "admin", "superadmin"];
const ADMIN = ["admin", "superadmin"];
const ALL = ["operateur", "magasinier", "planificateur", "superviseur", "admin", "superadmin"];

export const NAV_SECTIONS = [
  { title: "Pilotage", items: [
    { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, roles: PILOTAGE, api: "/dashboard" },
    { to: "/alertes", label: "Alertes & interventions", icon: Siren, roles: PILOTAGE, api: "/dashboard" },
    { to: "/trs", label: "TRS / OEE", icon: Gauge, roles: PILOTAGE, api: "/trs, /trs/tendance, /trs/par-quart" },
  ]},
  { title: "Production", items: [
    { to: "/of", label: "Ordres de fabrication", icon: ClipboardList, roles: PILOTAGE, api: "/of, /of/{id}/details, /of/kpi-planificateur" },
    { to: "/atelier", label: "Écran atelier", icon: MonitorPlay, roles: ALL, api: "/of?actifs=1, /of/{id}/atelier" },
    { to: "/archives", label: "Archives OF", icon: Archive, roles: PILOTAGE, api: "/of/archives, /of/archives/stats" },
  ]},
  { title: "Analyse", items: [
    { to: "/analyse", label: "Analyse & exports", icon: BarChart3, roles: PILOTAGE, api: "/analyse/*" },
  ]},
  { title: "Référentiels", items: [
    { to: "/admin/lignes", label: "Lignes & quarts actifs", icon: Factory, roles: ADMIN, api: "/lignes, /lignes/{id}/quarts-actifs" },
    { to: "/admin/produits", label: "Produits", icon: Package, roles: ADMIN, api: "/produits" },
    { to: "/admin/unites", label: "Unités de production", icon: Ruler, roles: ADMIN, api: "/production-unites" },
    { to: "/admin/quarts", label: "Quarts", icon: Clock, roles: ADMIN, api: "/quarts" },
    { to: "/admin/arrets", label: "Catégories d'arrêt", icon: OctagonX, roles: ADMIN, api: "/categories-arret" },
    { to: "/admin/rejets", label: "Motifs de rejet", icon: Ban, roles: ADMIN, api: "/motifs-rejet" },
  ]},
  { title: "Inventaire", items: [
    { to: "/inventaire", label: "Inventaire & traçabilité", icon: Boxes, roles: INVENTAIRE_LECTURE, module: "inventory", api: "/inventaire/*" },
    { to: "/admin/entrepots", label: "Configuration entrepôts", icon: Warehouse, roles: ADMIN, module: "inventory", api: "/inventaire/entrepots, /zones, /emplacements, /lignes/emplacement-defaut" },
  ]},
  { title: "Aide", items: [
    { to: "/aide", label: "Aide & manuels", icon: LifeBuoy, roles: ALL, api: "/ext/docs" },
  ]},
  { title: "Administration", items: [
    { to: "/admin/utilisateurs", label: "Utilisateurs & rôles", icon: Users, roles: ADMIN, api: "/users" },
    { to: "/admin/entreprise", label: "Entreprise & fuseau", icon: Globe, roles: ["admin"], api: "/entreprises/moi, /fuseaux-horaires" },
    { to: "/superadmin/entreprises", label: "Entreprises & forfaits", icon: Building2, roles: ["superadmin"], api: "/entreprises, /plans" },
  ]},
];

export const canAccess = (role, roles) => roles.includes(role);

export const homeFor = (role) =>
  role === "operateur" ? "/atelier"
  : role === "magasinier" ? "/inventaire"   // AUDIT INV V2 : magasinier atterrit sur Inventaire.
  : "/dashboard";

export const allNavItems = NAV_SECTIONS.flatMap((s) => s.items);
